import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "sh-application/components/previewSchedulePage/store/PreviewSchedulePageStore";

/**
 * Sets the force header expand boolean
 */
export default mutatorAction("SET_FORCE_HEADER_EXPAND",
    function setForceHeaderExpand(store: SchedulesViewStateStore | IPreviewSchedulePageStore, forceHeaderExpand: boolean) {
        store.forceHeaderExpand = forceHeaderExpand;
    }
);